import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";

export abstract class AnonServiceUsageStorage extends ServiceSessionStorageBase {
  protected readonly anonServiceStoreKey: string;

  constructor(
    anonServiceStoreKey: string,
    storeName: string,
    databaseName: string,
  ) {
    super(storeName, databaseName);

    this.anonServiceStoreKey = anonServiceStoreKey;
  }

  async getUsageCount(): Promise<number> {
    const usageCount = await this.getDataDB(this.anonServiceStoreKey);
    if (isNaN(usageCount)) {
      return 0;
    }

    return usageCount;
  }

  async setUsageCount(count: number): Promise<void> {
    await this.saveDataDB(this.anonServiceStoreKey, count);
  }
}
